export default "__VITE_ASSET__f1a0fc17__"